// @flow
import * as React from 'react';
import { connect } from 'react-redux';

import type { MapStateToProps } from 'react-redux';

import { setModal } from '../../ui/ui.actions.js';

import { selectInspectionsStatus } from '../calendar.selectors.js';

type OwnProps = {||};

type MappedState = {|
  UI: UI,
  URL: URL
|};

type Props = {|
  ...OwnProps,
  ...MappedState
|};

class ResourceDescription extends React.Component<Props> {
  generateEndorsements = endorsements => {
    const endorsementKeys = {
      complex: 'Complex',
      performance: 'High Performance',
      highAltitudeOperations: 'High Altitude Operations',
      tailwheel: 'Tailwheel'
    };
    return endorsements.map(endorsement => endorsementKeys[endorsement]).join(', ');
  };

  render() {
    const { UI, setModal, aircraft, medicalClass, inspectionsStatus } = this.props;

    if (!aircraft || !aircraft.id) return null;

    return (
      <div>
        <h5 className="discrepancies-modal-heading resource-wrap">
          Aircraft:{' '}
          <span className="resource-name" title={inspectionsStatus}>
            {aircraft.name}
            <span
              className={`
              inspections-status inspections-status--resource-details icon
              ${
                inspectionsStatus === 'Airworthy'
                  ? ' checkmark-circle text-success'
                  : inspectionsStatus === 'Unairworthy'
                  ? 'cancel-circled text-danger'
                  : ''
              }
            `}
              title={inspectionsStatus}
            />
          </span>
          <a
            className="text-muted show-details"
            onClick={() => setModal(!UI.modals.showDetails, 'showDetails')}
          >
            {UI.modals.showDetails ? 'Hide Details' : 'Show Details'}
          </a>
        </h5>

        {UI.modals.showDetails ? (
          <div className="aircraft-details text-muted">
            <div>
              <b>Registration Number:</b> {aircraft.regNumb.length ? aircraft.regNumb : 'Not set'}
            </div>
            {aircraft.medicalCertificate ? (
              <div>
                <b>Medical Certificate Required:</b>{' '}
                {medicalClass[aircraft.medicalCertificate]
                  ? medicalClass[aircraft.medicalCertificate].name
                  : 'None'}
              </div>
            ) : null}
            {aircraft.endorsements && aircraft.endorsements.length ? (
              <div>
                <b>Endorsements:</b> {this.generateEndorsements(aircraft.endorsements)}
              </div>
            ) : null}
            {aircraft.pilotRatingName ? (
              <div>
                <b>Pilot Rating Required:</b> {aircraft.pilotRatingName}
              </div>
            ) : null}
            {aircraft.instructorRatingName ? (
              <div>
                <b>Instructor Rating Required:</b> {aircraft.instructorRatingName}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  }
}
const mapStateToProps: MapStateToProps<ReduxState, OwnProps, MappedState> = state => ({
  UI: state.UI,
  URL: state.URL,
  aircraft: state.aircraft,
  medicalClass: state.medicalClass,
  inspectionsStatus: selectInspectionsStatus(state)
});

export default connect(
  mapStateToProps,
  {
    setModal
  }
)(ResourceDescription);
